<template>
  <div>
    <md-field :class="getValidationClass('identificacaoDoReservatorio')">
      <label for="identificacaoDoReservatorio"
        >Identificação do Reservatório</label
      >
      <md-input
        v-model.trim="reservatorio.identificacaoDoReservatorio"
        @change="handleChange"
      />
      <span
        v-if="!$v.reservatorio.identificacaoDoReservatorio.required"
        class="md-error"
        >Identificação do Reservatório é obrigatório</span
      >
    </md-field>

    <md-field :class="getValidationClass('volumeDoReservatario')">
      <label for="volumeDoReservatario">Volume do Reservatório (m3)</label>
      <md-input
        v-model.number="reservatorio.volumeDoReservatario"
        type="number"
        @change="handleChange"
      />
      <span
        v-if="!$v.reservatorio.volumeDoReservatario.required"
        class="md-error"
        >Volume do Reservatório do Tubo é obrigatório</span
      >
    </md-field>

    <md-field :class="getValidationClass('materialConstrutivo')">
      <label for="materialConstrutivo">Material Construtivo</label>
      <md-select
        id="materialConstrutivo"
        v-model="reservatorio.materialConstrutivo"
        name="materialConstrutivo"
        @md-selected="handleChange"
      >
        <md-option value="Residencial"> Residencial </md-option>
        <md-option value="Comercial"> Comercial </md-option>
        <md-option value="Publico"> Publico </md-option>
        <md-option value="Outro"> Outro </md-option>
      </md-select>
      <span
        v-if="!$v.reservatorio.materialConstrutivo.required"
        class="md-error"
        >Material Construtivo é obrigatório</span
      >
    </md-field>

    <md-field v-if="reservatorio.materialConstrutivo === 'Outro'">
      <label for="localInstalacaoOutro"
        >Especificar o Material Construtivo</label
      >
      <md-input
        v-model="reservatorio.materialConstrutivoOutro"
        @change="handleChange"
      />
    </md-field>

    <md-field :class="getValidationClass('tipoDoReservatorio')">
      <label for="localInstalacao">Tipo do Reservatório</label>
      <md-select
        id="localInstalacao"
        v-model="reservatorio.tipoDoReservatorio"
        name="localInstalacao"
        @md-selected="handleChange"
      >
        <md-option value="Residencial"> Residencial </md-option>
        <md-option value="Comercial"> Comercial </md-option>
        <md-option value="Publico"> Publico </md-option>
        <md-option value="Outro"> Outro </md-option>
      </md-select>
      <span v-if="!$v.reservatorio.tipoDoReservatorio.required" class="md-error"
        >Tipo do Reservatório é obrigatório</span
      >
    </md-field>

    <md-field v-if="reservatorio.tipoDoReservatorio === 'Outro'">
      <label for="localInstalacaoOutro"
        >Especificar o Tipo do Reservatório</label
      >
      <md-input
        v-model="reservatorio.tipoDoReservatorioOutro"
        @change="handleChange"
      />
    </md-field>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'FormularioReservatorioSig',
  mixins: [validationMixin],
  props: {
    data: Object,
  },
  data() {
    return {
      reservatorio: {
        identificacaoDoReservatorio: null,
        volumeDoReservatario: null,
        materialConstrutivo: null,
        materialConstrutivoOutro: null,
        tipoDoReservatorio: 'Publico',
        tipoDoReservatorioOutro: null,
      },
    }
  },
  validations: {
    reservatorio: {
      identificacaoDoReservatorio: { required },
      volumeDoReservatario: { required },
      materialConstrutivo: { required },
      materialConstrutivoOutro: null,
      tipoDoReservatorio: { required },
      tipoDoReservatorioOutro: null,
    },
  },
  beforeMount() {
    if (this.data) {
      this.reservatorio = { ...this.data }
    }
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.reservatorio[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    handleChange() {
      this.$v.$touch()

      this.$forceUpdate()

      this.$emit('change', {
        isValid: !this.$v.$invalid,
        data: { ...this.reservatorio },
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
